import { HStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { CredentialedScanningType } from '../../../types';

interface CredentialedScanTypeProps {
  scanningType: string;
}

export const CredentialedScanType = ({
  scanningType,
}: CredentialedScanTypeProps) => {
  const { t } = useTranslation('telemetryScannerConfig', {
    keyPrefix: 'credentialedScanningForm.typeOption',
  });

  return (
    <HStack gap="xsmall" wrap="wrap">
      {scanningType === CredentialedScanningType.Usk
        ? t('usernameSSHKey')
        : t('usernameOrPass')}
    </HStack>
  );
};
